"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

require("../../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _underscore = require("underscore");

var _Button = _interopRequireDefault(require("../buttons/Button"));

var _InputRow = _interopRequireDefault(require("../layout/InputRow"));

var _Link = _interopRequireDefault(require("../general/Link"));

var _Icon = _interopRequireDefault(require("../general/Icon"));

var renderRemoveIcon = function renderRemoveIcon(_ref) {
  var dataId = _ref["data-id"],
      onRemove = _ref.onRemove,
      removable = _ref.removable,
      id = _ref.id;
  return removable ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
    className: "row-builder__remove-icon",
    "data-id": dataId,
    type: "inline",
    onClick: function onClick(e) {
      return onRemove(e, id);
    },
    iconName: "delete"
  }) : null;
};

function Row(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "row-builder--form__row"
  }, children);
}

function Separator(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "row-builder--form__separator"
  }, children);
}
/**
 * @class Row Builder
 * @desc A component for building rows
 *
 * @param {string} [data-id="link"]
 *     To define the base "data-id" value for top-level HTML container.
 * @param {string} [className]
 *     CSS classes to be set on the inner Link container.
 * @param {node} [addLabel]
 *     Label for the button to add new rows.
 * @param {object} [rows]
 *     Rows for the component; must be an array of objects each with a string ID and
 *     a valid React node as its content property.
 * @param {boolean} [hasLineBetween=true]
 *     When true, lines and wider spacing are rendered between rows.
 * @param {boolean} [showRemoveLabel]
 *     Toggles whether or not remove button has a label on first row.
 * @param {node|function} [renderAddButton]
 *     Located below the row builder; normally an add link by default. Can be either a node
 *     a function that returns a function; the function is given the RowBuilder's onAdd.
 * @param {node|function} [renderRemoveButton]
 *     Located on the right each of the row builder; normally an inline button with a minus icon.
 *     Can be either a node a function that returns a function; the function is given the RowBuilder's onRemove.
 * @param {RowBuilder~onAdd} [onAdd]
 *     Callback triggered when add button is clicked. Passes in event as its parameter.
 * @param {RowBuilder~onRemove} [onRemove]
 *     Callback triggered when remove button is clicked. Passes back event and row ID.
 *
 */


function RowBuilder(_ref4) {
  var addLabel = _ref4.addLabel,
      className = _ref4.className,
      dataId = _ref4["data-id"],
      hasLineBetween = _ref4.hasLineBetween,
      onAdd = _ref4.onAdd,
      onRemove = _ref4.onRemove,
      renderAddButton = _ref4.renderAddButton,
      renderRemoveButton = _ref4.renderRemoveButton,
      rows = _ref4.rows,
      showRemoveLabel = _ref4.showRemoveLabel;

  var add = function add(e) {
    if (onAdd) {
      onAdd(e);
    }
  };

  var remove = function remove(id) {
    return function (e) {
      if (onRemove) {
        onRemove(e, id);
      }
    };
  };

  var renderRow = function renderRow(_ref5, idx) {
    var _context;

    var id = _ref5.id,
        content = _ref5.content,
        _ref5$removable = _ref5.removable,
        removable = _ref5$removable === void 0 ? true : _ref5$removable;
    var hasRemoveLabel = showRemoveLabel && idx === 0;
    var rowId = (0, _concat.default)(_context = "".concat(dataId, "-")).call(_context, id, "-delete");
    return /*#__PURE__*/_react.default.createElement(_InputRow.default, {
      className: "row-builder__row",
      key: id
    }, content, /*#__PURE__*/_react.default.createElement("div", {
      className: "row-builder__remove"
    }, hasRemoveLabel && /*#__PURE__*/_react.default.createElement("div", {
      className: "row-builder__remove__label"
    }, " Remove "), renderRemoveButton ? (0, _underscore.isFunction)(renderRemoveButton) ? renderRemoveButton({
      "data-id": rowId,
      id: id,
      onRemove: onRemove,
      removable: removable
    }) : renderRemoveButton : /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: (0, _classnames.default)("row-builder__remove__button", {
        "row-builder__remove__button--hidden": !removable
      }),
      "data-id": rowId,
      iconName: "delete",
      inline: true,
      onClick: remove(id)
    })));
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)("row-builder", className, {
      "row-builder--underlined": hasLineBetween
    }),
    "data-id": dataId
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)({
      "row-builder__rows": rows.length > 0
    })
  }, (0, _map.default)(rows).call(rows, renderRow)), /*#__PURE__*/_react.default.createElement("div", {
    className: "row-builder__add"
  }, renderAddButton ? (0, _underscore.isFunction)(renderAddButton) ? renderAddButton({
    onAdd: onAdd
  }) : renderAddButton : /*#__PURE__*/_react.default.createElement(_Link.default, {
    "data-id": "row-builder-add",
    onClick: add,
    title: addLabel,
    type: "block"
  })));
}

RowBuilder.defaultProps = {
  addLabel: "+ Add",
  "data-id": "row-builder",
  hasLineBetween: true,
  rows: []
};
RowBuilder.propTypes = {
  addButton: _propTypes.default.node,
  addLabel: _propTypes.default.node,
  className: _propTypes.default.string,
  "data-id": _propTypes.default.string,
  onAdd: _propTypes.default.func,
  onRemove: _propTypes.default.func,
  renderAddButton: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
  renderRemoveButton: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
  rows: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string,
    content: _propTypes.default.node,
    removable: _propTypes.default.bool
  })),
  showRemoveLabel: _propTypes.default.bool
};
RowBuilder.Row = Row;
RowBuilder.Separator = Separator;
RowBuilder.renderRemoveIcon = renderRemoveIcon;
var _default = RowBuilder;
exports.default = _default;
module.exports = exports["default"];